import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ToastController,LoadingController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the EditvalutazionePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-editvalutazione',
  templateUrl: 'editvalutazione.html',
})
export class EditvalutazionePage {
  valutazione;
  disattivo=true;
  cat="valut";
  ordine;
  ordineMenu;
  errorMessage;
  ordineItem;
  infoStore;
  constructor(public navCtrl: NavController, public navParams: NavParams,public rest: RestApiProvider,
    private readonly toastCtrl: ToastController,
    private readonly loadingCtrl: LoadingController,


    ) {
    this.valutazione = navParams.get('valutazione');
      this.ordine=this.valutazione.ordine;
    //alert(JSON.stringify(this.valutazione.ordine));
  }
  getOrdinazione(){
    this.rest.getOrdineDayList
  }
  CommentChange() {
    console.log('FIRED');
    this.disattivo=false;

	}
  invioRisposta(){
    this.rest.aggiornaValutazione(this.valutazione);
    const toast = this.toastCtrl.create({

      message:"Risposta inviato con successo!",

      duration: 3000,

      position: 'bottom'

    });



    toast.present();
    this.disattivo=true;

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad EditvalutazionePage');
    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',

      content: 'loading ...'

    });
    loading.present();

    this.getOrdineItem();
    this.getOrdineMenu();
    loading.dismiss();
  }
  getOrdineMenu() {
    this.rest.getOrdineMenu(this.ordine.id).subscribe(
      ordineMenu => this.ordineMenu = ordineMenu,
      error => this.errorMessage = <any>error);
  }
  getOrdineItem() {
    this.rest.getOrdineItemList(this.ordine.id).subscribe(
      ordineItem => this.ordineItem = ordineItem,
      error => this.errorMessage = <any>error);
  }
 
}



// WEBPACK FOOTER //
// ./src/pages/editvalutazione/editvalutazione.ts